import * as React from 'react';

import { ErrorFallback } from 'components/error_boundary/components/ErrorFallback';
import { sendErrorBoundaryReport } from 'utils/consoleOverride';

type ErrorBoundaryProps = {
    children: React.ReactNode;
};

type ErrorBoundaryState = {
    error: Error | null;
    errorInfo: React.ErrorInfo | null;
};

export class ErrorBoundary extends React.Component<ErrorBoundaryProps, ErrorBoundaryState> {

    constructor(props: ErrorBoundaryProps) {

        super(props);
        this.state = {
            error: null,
            errorInfo: null
        };

    }

    static getDerivedStateFromError(error: Error): Partial<ErrorBoundaryState> {

        return { error };

    }

    componentDidCatch(error: Error, errorInfo: React.ErrorInfo) {

        console.error(error, errorInfo);
        this.setState({ errorInfo });

        sendErrorBoundaryReport(error, {
            componentStack: errorInfo.componentStack ?? ''
        });

    }

    render(): React.ReactNode {

        const { error, errorInfo } = this.state;

        if (error && errorInfo) {

            return <ErrorFallback error={error} errorInfo={errorInfo} />;

        }

        return this.props.children;

    }

}
